let ss
export function initBirds (svgpath) {
  if (ss !== undefined) return

  document.head.appendChild(document.createElement('style'))
  ss = document.styleSheets[document.styleSheets.length - 1]

  ss.insertRule(`
    .__birdRoot__JC {
        background-image: url(${svgpath});
        background-repeat: no-repeat;
        background-position: left top;
        position: relative;
        background-size: contain;
        top: 0px;
        left: 0px;
      }
    `)
  ss.insertRule(`
    .__boxRoot__JC {
      position: absolute;
      overflow: hidden;
      z-index:100;
    }
    `)
}

let BIRD_COUNTER = 0

export function addBird (cfg) {
  const birdnum = BIRD_COUNTER
  BIRD_COUNTER += 1
  const cht = Math.floor(cfg.cellWidth * 1.6)
  const strip = Math.floor(cfg.cellWidth * 10)

  ss.insertRule(`
    .bird_${birdnum} {
        height: ${cht}px;
        width: ${strip}px;
        animation: _kf_bird${birdnum}_cellframes ${cfg.flapTimeSecs}s steps(10) infinite;
        opacity: ${cfg.opacity};
      }
    `)
  console.log(cfg)
  const y = Number.isFinite(+cfg.bottom) ? `${cfg.bottom}px` : cfg.bottom
  console.log(y)
  ss.insertRule(`
    .box_${birdnum} {
      bottom: ${y};
      left: ${-cfg.cellWidth}px;
      height: ${cht}px;
      width: ${cfg.cellWidth}px;
      animation: _kf_bird${birdnum}_flight ${cfg.flightTimeSecs}s linear infinite;
      animation-delay: ${cfg.startDelaySecs}s;
    }
    `)

  if (!cfg.noDomInsert) {
    const divBox = document.createElement('div')
    divBox.classList.add('__boxRoot__JC', `box_${birdnum}`)
    const divBird = document.createElement('div')
    divBird.classList.add('__birdRoot__JC', `bird_${birdnum}`)
    divBox.appendChild(divBird)
  }

  ss.insertRule(`@keyframes _kf_bird${birdnum}_flight {  100% { transform: translateX(120vw); } }`)
  ss.insertRule(`@keyframes _kf_bird${birdnum}_cellframes { 100% { transform: translateX(-${strip}px); } }`)

  return birdnum
}



// WEBPACK FOOTER //
// ./src/lib/my-birds.js